export default __webpack_public_path__ + "static/media/Anyswap.491d1f32.svg";